import { useProjectId, useSessionChecker } from '@btime/react-session'
import React from 'react'

import { useLoggedUserAutoReloader } from '../../../utils/session/reloadLoggedUser'
import { useQueryParams } from '../../../utils/contexts/UrlProvider'
import AuthWithToken from './AuthWithToken'
import HomePage from '../../home/HomePage'
import Loading from '../../../components/helpers/Loading'
import LoginPage from '../login/LoginPage'
import PermalinkAuth from './PermalinkAuth'
import AuthWithSSOToken from './AuthWithSSOToken'
import AuthFromAdmin from './AuthFromAdmin'

const Auth = ({ children }) => {
  const qp = useQueryParams()
  const forceTokenLogin = qp.token
  const permalinkToken = qp.t
  const ssoToken = qp.ssoToken
  const userId = qp.userId
  const sessionReference = qp.sessionReference
  const projectId = useProjectId()

  const [isLogged, loading] = useSessionChecker()

  useLoggedUserAutoReloader()

  if (permalinkToken) {
    return <PermalinkAuth token={permalinkToken} children={children} />
  }

  if (forceTokenLogin) {
    return <AuthWithToken token={forceTokenLogin} children={children} />
  }

  if (ssoToken) {
    return <AuthWithSSOToken ssoToken={ssoToken} userId={userId} children={children} />
  }

  if (sessionReference) {
    return <AuthFromAdmin sessionReference={sessionReference} userId={userId} children={children} />
  }

  if (loading) {
    return <Loading />
  }

  if (!isLogged) {
    return <LoginPage />
  }

  if (!projectId) {
    return <HomePage />
  }

  return children
}

export default Auth
